import { render, staticRenderFns } from "./agam_ReleaseFilter.vue?vue&type=template&id=09706b1a&"
import script from "./agam_ReleaseFilter.vue?vue&type=script&lang=js&"
export * from "./agam_ReleaseFilter.vue?vue&type=script&lang=js&"
import style0 from "./agam_ReleaseFilter.vue?vue&type=style&index=0&id=09706b1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports